/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createSentEmailDetailDtoFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type SentEmailDetailDto } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/emails/sent/{emailId}
 */
export interface WithEmailItemRequestBuilder extends BaseRequestBuilder<WithEmailItemRequestBuilder> {
    /**
     * Returns one sent email with every delivery event recorded for it, oldest first: when it was sent, delivered, delayed, opened, clicked (with the link), bounced or marked as spam, and the bounce reason. Only the organization's own emails are visible.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<SentEmailDetailDto>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 404 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<SentEmailDetailDto | undefined>;
    /**
     * Returns one sent email with every delivery event recorded for it, oldest first: when it was sent, delivered, delayed, opened, clicked (with the link), bounced or marked as spam, and the bounce reason. Only the organization's own emails are visible.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithEmailItemRequestBuilderUriTemplate = "{+baseurl}/api/emails/sent/{emailId}";
/**
 * Metadata for all the requests in the request builder.
 */
export const WithEmailItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: WithEmailItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createSentEmailDetailDtoFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
